import React, { useEffect, useState } from "react";
import styles from "./Overview.module.scss";
import OverviewProduct from "./OverviewProduct/OverviewProduct";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../../../routes";
import OverviewProductShimmer from "./OverviewProductShimmer/OverviewProductShimmer";
import logo from "../../../../../assets/logos/golden-logo.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCartItemAction,
  editToCartAction,
  getCartListAction,
  setCartItems,
  setCartUpdateFlag,
} from "../../../../../features/marketPlace/marketPlaceSlice";
import NoContent from "../../../NoContent/NoContent";
import { saveCartCount } from "../../../../../features/persist/persistSlice";

const Overview = ({
  closeCart,
  setSubTotal,
  setTax,
  cartList,
  setCartList,
  getRangePrice,
  coinLists,
  paymentMode,
  updateCartItem,
}) => {
  const dispatch = useDispatch();
  const spotPrice = useSelector((state) => state?.users?.spotPrice);
  const spotPremiumPrice = useSelector((state) => state?.users?.spotPremiumPrice);

  const [loading, setLoading] = useState(true);
  const [imageURL, setImageURL] = useState("");

  const handleViewProducts = () => {
    closeCart && closeCart();
  };

  useEffect(() => {
    getCartItems();
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const handleQtyChange = async (
    item,
    operator,
    value,
    decimal,
    minOrderQty,
    orderValue = null // Add this parameter
  ) => {
    const index = cartList?.findIndex((o) => o.product_id == item.product_id);
    if (index < 0) return;

    let list = [...cartList];
    let newQuantity;
    let newValue;

    // Calculate base price
    const basePrice =
      item?.token_id == 1
        ? spotPremiumPrice?.goldPrice || 0
        : spotPremiumPrice?.silverPrice || 0;

    if (item.selection_mode === "VALUE") {
      // For VALUE mode, input value is the total value ($), quantity is derived
      let unitPrice;
      if (value !== undefined) {
        newValue = orderValue !== null ? orderValue : Number(value); // Use orderValue if provided
        // Approximate quantity for range fee calculation
        let approxQty = newValue / (basePrice || 1);
        unitPrice = basePrice + getRangePrice(approxQty, item.product_price_chart, paymentMode);
        newQuantity = unitPrice ? newValue / unitPrice : minOrderQty;
      } else if (operator === "+") {
        // Increment order_value by minOrderQty * unitPrice
        newQuantity = Number(list[index].quantity || 0) + minOrderQty;
        unitPrice = basePrice + getRangePrice(newQuantity, item.product_price_chart, paymentMode);
        newValue = newQuantity * unitPrice;
      } else if (operator === "-" && Number(list[index].quantity || 0) > minOrderQty) {
        // Decrement order_value by minOrderQty * unitPrice
        newQuantity = Number(list[index].quantity || 0) - minOrderQty;
        unitPrice = basePrice + getRangePrice(newQuantity, item.product_price_chart, paymentMode);
        newValue = newQuantity * unitPrice;
      } else {
        newQuantity = Number(list[index].quantity || 0);
        unitPrice = basePrice + getRangePrice(newQuantity, item.product_price_chart, paymentMode);
        newValue = newQuantity * unitPrice;
      }

      // Enforce minimum order quantity
      unitPrice = basePrice + getRangePrice(newQuantity, item.product_price_chart, paymentMode);
      if (newQuantity < minOrderQty) {
        newQuantity = minOrderQty;
        newValue = minOrderQty * unitPrice;
      }

      // Update cart item - IMPORTANT: Include order_value
      list[index] = {
        ...list[index],
        quantity: newQuantity.toFixed(decimal),
        order_value: newValue.toFixed(2), // Add this line!
        price: unitPrice.toFixed(2),
      };
    } else {
      // For QUANTITY mode, input value is the quantity
      if (value !== undefined) {
        newQuantity = Number(value);
      } else if (operator === "+") {
        newQuantity = Number(
          (Number(list[index].quantity || 0) + minOrderQty).toFixed(decimal)
        );
      } else if (operator === "-" && Number(list[index].quantity || 0) > minOrderQty) {
        newQuantity = Number(
          (Number(list[index].quantity || 0) - minOrderQty).toFixed(decimal)
        );
      } else {
        newQuantity = Number(list[index].quantity || 0);
      }

      // Enforce minimum order quantity
      if (newQuantity < minOrderQty) {
        newQuantity = minOrderQty;
      }

      // Calculate range fee and unit price
      const rangeFee = getRangePrice(newQuantity, item.product_price_chart, paymentMode);
      const unitPrice = basePrice + rangeFee;
      newValue = newQuantity * unitPrice;
     

      // Update cart item
      list[index] = {
        ...list[index],
        quantity: newQuantity.toFixed(decimal),
        price: unitPrice.toFixed(2),
      };
    }

    setCartList(list);
    updateCartItem(list[index]);

    try {
      const dataObj = {
        cartId: item?.id,
        productId: item?.product_id,
        quantity: newQuantity,
        price: list[index].price,
        orderValue: newValue ? newValue : 0
      };
      const response = await dispatch(editToCartAction(dataObj));
      if (response.status === 200) {
        await getCartItems();
        // Subtotal and tax are handled by Cart's useEffect
      }
    } catch (error) {
      console.log("Error updating cart:", error);
    }
  };

  const getCartItems = async () => {
    try {
      const response = await dispatch(getCartListAction());
      if (response.status === 200) {
        setCartList(response.data.data.items);
        dispatch(saveCartCount(response?.data?.data?.items?.length));
        setImageURL(response.data.data.productImgUrl);
      }
    } catch (error) { }
  };

  const handleRemoveFromCart = async (cartItem) => {
    try {
      const response = await dispatch(
        deleteCartItemAction({ cartItemId: cartItem?.id })
      );
      if (response.status === 200) {
        dispatch(setCartUpdateFlag(true));
        getCartItems();
      }
    } catch (error) { }
  };

  return (
    <div className={styles.overview}>
      {cartList.length != 0 && <h6>Products</h6>}
      <ul className={styles.overview_list}>
        {loading ? (
          <li>
            <OverviewProductShimmer />
          </li>
        ) : (
          cartList.length != 0 &&
          cartList?.map((item) => (
            <li key={item.id}>
              <OverviewProduct
                name={item?.product?.title}
                productData={item}
                baseURL={imageURL}
                handleIncDec={handleQtyChange}
                handleRemoveFromCart={handleRemoveFromCart}
                coinLists={coinLists}
                getRangePrice={getRangePrice}
                paymentMode={paymentMode}
              />
            </li>
          ))
        )}
      </ul>
      {cartList.length !== 0 ? (
        <Link to={ROUTES.MARKETPLACE} onClick={handleViewProducts}>
          Add More Products
        </Link>
      ) : (
        <>
          {!loading && cartList.length === 0 && (
            <NoContent
              className={styles.no_record}
              content="Items added to cart will be shown here."
            />
          )}
          <Link to={ROUTES.MARKETPLACE} onClick={handleViewProducts}>
            View Products
          </Link>
        </>
      )}
    </div>
  );
};

export default Overview;